<template>
  <div class="flex flex-col">
    <div class="flex flex-row gap-2">
      <BlueIconButton @click="pausePrinting">
        <WhitePauseIcon />
      </BlueIconButton>

      <BlueIconButton @click="cancelPrinting">
        <WhiteSquareIcon />
      </BlueIconButton>
    </div>

    <BaseKeyValue :cles="t('fileName')">
      <SimpleText :content="printingInfo.result.status.print_stats.filename" />
    </BaseKeyValue>

    <BaseKeyValue :cles="t('remainingTime')">
      <SimpleText :content="remainingTime" />
    </BaseKeyValue>

    <BaseKeyValue :cles="t('progress')">
      <SimpleText :content="converter.floor(printingInfo.result.status.display_status.progress)" />
    </BaseKeyValue>
  </div>
</template>

<script setup>

import {computed, defineProps} from "vue";
import BaseKeyValue from "@/components/molecules/BaseKeyValue.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";
import {t} from "@/utils/Traduction";
import converter from "@/utils/Converter";
import WhitePauseIcon from "@/components/atoms/WhitePauseIcon.vue";
import BlueIconButton from "@/components/molecules/BlueIconButton.vue";
import WhiteSquareIcon from "@/components/atoms/WhiteSquareIcon.vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";
import {NotificationStores} from "@/stores/NotificationStores";

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
  printingInfo: {
    type: Object,
    required: true,
  },
});

const notificationStores = NotificationStores();

const remainingTime = computed(() => {
  const progress = props.printingInfo.result.status.display_status.progress;
  const print_duration = props.printingInfo.result.status.print_stats.print_duration;

  const estimated_total = print_duration / progress;
  const remaining_time = estimated_total - print_duration;

  return converter.secondsToTime(Math.round(remaining_time));
});

const pausePrinting = () => {
  xhr.addRequestToQueue("POST", "/imprimantes/printing/pause/" + props.uuid, null, true, true, false,
      async (response) => {
        if(response.code !== 200) {

          if(response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStores.addNotification(
                t("errorDuringServerConnexion"),
                "error");
          } else {
            notificationStores.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStores.addNotification(
              t("printPaused"),
              "success");
        }
      });
}

const cancelPrinting = () => {
  xhr.addRequestToQueue("POST", "/imprimantes/printing/cancel/" + props.uuid, null, true, true, false,
      async (response) => {
        if(response.code !== 200) {

          if(response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStores.addNotification(
                t("errorDuringServerConnexion"),
                "error");
          } else {
            notificationStores.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStores.addNotification(
              t("printCancelled"),
              "success");
        }
      });
}

</script>

<style scoped>

</style>